<template>
  <div class="three-meeting">
    <div class="top">
      <img src="@/assets/partyhome/threeClass/dp-dy-sh5.png" alt />
      <div class="msg">
        <div class="header">
          <i class="el-icon-back" @click="goBack"></i>
          <span>三会一课</span>
        </div>
        <div class="adress">
          <img src="@/assets/partyhome/threeClass/dp-dy-sh4.png" alt />
          <span>{{ partyBrach }}</span>
        </div>
      </div>

      <!-- 三会一课模板 -->
      <div class="list-box">
        <div
          class="list-template"
          v-for="(list, index) in lists"
          :key="list.title"
          @click="goName(index)"
        >
          <div>
            <img :src="list.imgUrl" alt />
          </div>
          <div>
            <p v-text="list.title"></p>
            <p v-text="list.content"></p>
          </div>
          <div>
            <i class="el-icon-right"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- 新闻 -->
    <div class="remoteEdu">
      <div class="title">
        <p>活动记录</p>
        <p @click="goList">查看全部</p>
      </div>
      <div
        class="news-template"
        v-for="news in sevenLine"
        :key="news.imgUrl"
        @click="goActiveDetail(news.id)"
      >
        <div class="news-left">
          <img
            :src="news.img | filterB"
            alt
            v-if="news.img == null ? false : true"
          />
        </div>
        <div class="news-right">
          <p>{{ news.title }}</p>
          <p>
            <!-- <span style="margin-right: 0.5rem">浏览:{{ news.sees }}</span>
            <span>点赞:{{ news.praise }}</span> -->
            <span style="margin-right: 0.3rem; float: right">{{
              news.time | times
            }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      lists: [
        {
          imgUrl: require("@/assets/partyhome/threeClass/dp-dy-sh6.png"),
          title: "创建活动",
          content: "“三会一课”活动创建提交",
        },
        {
          imgUrl: require("@/assets/partyhome/threeClass/dp-dy-sh7.png"),
          title: "编辑活动",
          content: "“三会一课”已创建活动编辑",
        },
        {
          imgUrl: require("@/assets/partyhome/threeClass/dp-dy-sh8.png"),
          title: "活动签到",
          content: "“三会一课”成员到场情况",
        },
      ],
      sevenLine: [],
      partyBrach: sessionStorage.getItem("partybrach"),
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    goDetail(newsid) {
      this.$router.push({
        path: "/publicDetail",
        query: { title: "远程教育", id: newsid, dbnum: 0 },
      });
    },
    goList() {
      this.$router.push({
        path: "/partyhome/threemeeting/activerecord",
        query: { title: "活动记录" },
      });
    },
    goName(index) {
      console.log(index);
      switch (index) {
        case 0:
          this.$router.push({
            path: "_createactive",
            query: { title: "创建活动" },
          });
          break;
        case 1:
          this.$router.push({
            path: "_editactive",
            query: { title: "编辑活动" },
          });
          break;
        case 2:
          this.$router.push({
            path: "_signactive",
            query: { title: "活动签到" },
          });
          break;
      }
    },
    goActiveDetail(newsid) {
      this.$router.push({
        path: "/publicDetail",
        query: { title: "三会一课资讯", id: newsid, dbnum: 3 }
      });
    },
  },
  created: function () {
    if (sessionStorage.getItem("token") == null) {
      this.$router.push("login");
    } else {
      this.axios
        .post("/api/Party/ActivityCount", {
          typename: sessionStorage.getItem("token"),
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.sevenLine = res.data.msg;
          }
        });
    }
  },
};
</script>

<style lang="scss" scoped>
.three-meeting {
  .remoteEdu {
    .title {
      display: flex;
      background: #fff;
      padding: 0 0.4rem;
      line-height: 3;
      justify-content: space-between;
    }
    .news-template {
      width: 94%;
      margin: 0 auto;
      display: flex;
      margin-bottom: 0.2rem;
      background: #fff;
      padding: 0.2rem 0;
      margin-top: 0.3rem;
      //   align-items: center;
      .news-right {
        width: 100%;
        margin-left: 0.2rem;
        p:nth-child(1) {
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
          display: -webkit-box;
          margin-bottom: 0.3rem;
          line-height: 1.8;
        }
        p:nth-child(2) {
          border-top: 0.01rem solid #e6e6e6;
          padding-top: 0.2rem;
          color: #999999;
          font-size: 0.26rem;
        }
      }
      .news-left {
        img {
          width: 2.4rem;
          height: 2rem;
        }
      }
    }
    margin-top: 0.3rem;
    // background: #fff;
  }
  .top {
    .list-box {
      .list-template {
        div {
          &:nth-child(1) {
          }
          &:nth-child(2) {
            p {
              &:nth-child(1) {
                text-indent: 0.15rem;
                font-weight: bold;
              }
              &:nth-child(2) {
                color: #999999;
              }
            }
          }
          &:nth-child(3) {
          }
        }
        i {
          font-size: 0.5rem;
        }
        img {
          width: 1.7rem;
          height: 1.7rem;
        }
        display: flex;
        align-items: center;
        justify-content: space-around;
        box-shadow: 0px 0px 0.1rem 0px rgba(0, 0, 0, 0.1);
        border-radius: 0.04rem;
        margin-bottom: 0.2rem;
      }
      position: absolute;
      width: 90%;
      left: 5%;
      top: 2.5rem;
      background: #fff;
    }
    .msg {
      .adress {
        span {
          position: relative;
          &::before {
            position: absolute;
            width: 20%;
            left: 2%;
            background: #fff;
            height: 0.08rem;
            content: "";
            border-right: 0.1rem;
            bottom: -0.2rem;
          }
        }
        img {
          width: 0.3rem;
          height: 0.3rem;
          margin-right: 0.2rem;
        }
        display: flex;
        align-items: center;
        color: #fff;
        margin-top: 0.2rem;
      }
      .header {
        i {
          margin-right: 0.2rem;
        }
        color: #fff;
        font-size: 0.5rem;
      }
      position: absolute;
      top: 0.2rem;
      left: 0.2rem;
    }
    img {
      width: 100%;
    }
    width: 100%;
    background: #fff;
    position: relative;
    height: 65vh;
  }
  font-size: 0.3rem;
}
</style>